import {IFieldModal} from '../components/pages/field-management/custom-field/constant';

export const tagFieldmockData: IFieldModal[] = [
  {
    fieldId: 5,
    fieldESType: 'Keyword',
    fieldCategoryLabel: 'Standard Metadata',
    fieldCategory: 'STANDARD_METADATA',
    fieldLabel: 'Tag Field 1',
    fieldName: '',
    canCustomize: false,
    isMultiValueField: false,
    isRelationShipField: true,
    tagValues: [
      {
        tagValueId: 71,
        tagValue: 'Tag 4',
        displayOrder: 1,
        isDeleted: false,
      },
      {
        tagValueId: 72,
        tagValue: 'Tag 5',
        displayOrder: 2,
        isDeleted: false,
      },
      {
        tagValueId: 90,
        tagValue: 'Tag 91',
        displayOrder: 1,
        isDeleted: false,
      },
      {
        tagValueId: 91,
        tagValue: 'Tag 92',
        displayOrder: 2,
        isDeleted: false,
      },
      {
        tagValueId: 92,
        tagValue: 'Tag 93',
        displayOrder: 3,
        isDeleted: false,
      },
      {
        tagValueId: 93,
        tagValue: 'Tag 94',
        displayOrder: 4,
        isDeleted: false,
      },
      {
        tagValueId: 94,
        tagValue: 'Tag 95',
        displayOrder: 5,
        isDeleted: false,
      },
      {
        tagValueId: 95,
        tagValue: 'Dup Tag value',
        displayOrder: 6,
        isDeleted: false,
      },
      {
        tagValueId: 96,
        tagValue: 'Dup Tag value 1',
        displayOrder: 7,
        isDeleted: false,
      },
    ],
    createdBy: 'SystemName',
    createdOn: '2025-02-12T07:30:53.9656678Z',
    updatedBy: 'SystemName',
    updatedOn: '2025-02-13T07:30:53.9656679Z',
  },
  {
    fieldId: 6,
    fieldESType: 'Text',
    fieldCategoryLabel: 'Standard Metadata',
    fieldCategory: 'STANDARD_METADATA',
    fieldLabel: 'ProjDb Field 4',
    fieldName: '',
    canCustomize: false,
    isMultiValueField: false,
    isRelationShipField: true,
    tagValues: [
      {
        tagValueId: 701,
        tagValue: 'Tag 40',
        displayOrder: 1,
        isDeleted: false,
      },
      {
        tagValueId: 720,
        tagValue: 'Tag 50',
        displayOrder: 2,
        isDeleted: false,
      },
      {
        tagValueId: 900,
        tagValue: 'Tag 910',
        displayOrder: 1,
        isDeleted: false,
      },
      {
        tagValueId: 910,
        tagValue: 'Tag 920',
        displayOrder: 2,
        isDeleted: false,
      },
      {
        tagValueId: 902,
        tagValue: 'Tag 930',
        displayOrder: 3,
        isDeleted: false,
      },
      {
        tagValueId: 903,
        tagValue: 'Tag 940',
        displayOrder: 4,
        isDeleted: false,
      },
      {
        tagValueId: 904,
        tagValue: 'Tag 950',
        displayOrder: 5,
        isDeleted: false,
      },
      {
        tagValueId: 950,
        tagValue: 'Dup Tag value0',
        displayOrder: 6,
        isDeleted: false,
      },
      {
        tagValueId: 960,
        tagValue: 'Dup Tag value 10',
        displayOrder: 7,
        isDeleted: false,
      },
    ],
    createdBy: 'SystemName',
    createdOn: '2025-01-27T07:30:53.9656682Z',
    updatedBy: 'SystemName',
    updatedOn: '2025-01-31T07:30:53.9656683Z',
  },
  {
    fieldId: 7,
    fieldESType: 'NESTED',
    fieldCategoryLabel: 'Custom Tag',
    fieldCategory: 'TAG_FIELD',
    fieldLabel: 'Review (CT) Field 1',
    fieldName: '',
    canCustomize: true,
    isMultiValueField: false,
    isRelationShipField: true,
    tagValues: [
      {
        tagValueId: 60,
        tagValue: 'Tag 1',
        displayOrder: 1,
        isDeleted: false,
      },
      {
        tagValueId: 61,
        tagValue: 'Tag 2',
        displayOrder: 2,
        isDeleted: false,
      },
      {
        tagValueId: 62,
        tagValue: 'Tag 3',
        displayOrder: 3,
        isDeleted: false,
      },
      {
        tagValueId: 63,
        tagValue: 'Tag 4',
        displayOrder: 4,
        isDeleted: false,
      },
      {
        tagValueId: 64,
        tagValue: 'Tag 5',
        displayOrder: 5,
        isDeleted: false,
      },
      {
        tagValueId: 52,
        tagValue: 'Tag 6',
        displayOrder: 6,
        isDeleted: false,
      },
      {
        tagValueId: 66,
        tagValue: 'Tag 7',
        displayOrder: 7,
        isDeleted: false,
      },
      {
        tagValueId: 67,
        tagValue: 'Tag 8',
        displayOrder: 8,
        isDeleted: false,
      },
      {
        tagValueId: 68,
        tagValue: 'Tag 9',
        displayOrder: 9,
        isDeleted: false,
      },
    ],
    createdBy: 'Godfrey Tearle',
    createdOn: '2024-10-14T07:30:53.9656696Z',
    updatedBy: 'Simon Kelly',
    updatedOn: '2025-01-14T07:30:53.9656697Z',
  },
  {
    fieldId: 11,
    fieldESType: 'NESTED',
    fieldCategoryLabel: 'Custom Tag',
    fieldCategory: 'TAG_FIELD',
    fieldLabel: 'Review (CT) Field 2',
    fieldName: '',
    canCustomize: true,
    isMultiValueField: false,
    isRelationShipField: true,
    tagValues: [
      {
        tagValueId: 71,
        tagValue: 'Tag 4',
        displayOrder: 1,
        isDeleted: false,
      },
      {
        tagValueId: 72,
        tagValue: 'Tag 5',
        displayOrder: 2,
        isDeleted: false,
      },
      {
        tagValueId: 90,
        tagValue: 'Tag 91',
        displayOrder: 1,
        isDeleted: false,
      },
      {
        tagValueId: 91,
        tagValue: 'Tag 92',
        displayOrder: 2,
        isDeleted: false,
      },
      {
        tagValueId: 92,
        tagValue: 'Tag 93',
        displayOrder: 3,
        isDeleted: false,
      },
      {
        tagValueId: 93,
        tagValue: 'Tag 94',
        displayOrder: 4,
        isDeleted: false,
      },
      {
        tagValueId: 94,
        tagValue: 'Tag 95',
        displayOrder: 5,
        isDeleted: false,
      },
      {
        tagValueId: 95,
        tagValue: 'Dup Tag value',
        displayOrder: 6,
        isDeleted: false,
      },
      {
        tagValueId: 96,
        tagValue: 'Dup Tag value 1',
        displayOrder: 7,
        isDeleted: false,
      },
    ],
    createdBy: 'Godfrey Tearle',
    createdOn: '2025-01-14T07:30:53.9656704Z',
    updatedBy: 'Simon Kelly',
    updatedOn: '2025-01-31T07:30:53.9656705Z',
  },
  {
    fieldId: 12,
    fieldESType: 'NESTED',
    fieldCategoryLabel: 'Custom Tag',
    fieldCategory: 'TAG_FIELD',
    fieldLabel: 'Review (CT) Field 3',
    fieldName: '',
    canCustomize: true,
    isMultiValueField: false,
    isRelationShipField: true,
    tagValues: [
      {
        tagValueId: 151,
        tagValue: 'Tag 111',
        displayOrder: 1,
        isDeleted: false,
      },
      {
        tagValueId: 152,
        tagValue: 'Tag 211',
        displayOrder: 2,
        isDeleted: false,
      },
      {
        tagValueId: 153,
        tagValue: 'Tag 313',
        displayOrder: 3,
        isDeleted: false,
      },
      {
        tagValueId: 251,
        tagValue: 'Tag 211',
        displayOrder: 4,
        isDeleted: false,
      },
      {
        tagValueId: 252,
        tagValue: 'Tag 2sf1',
        displayOrder: 5,
        isDeleted: false,
      },
      {
        tagValueId: 253,
        tagValue: 'Tag 3sdfs3',
        displayOrder: 6,
        isDeleted: false,
      },
      {
        tagValueId: 351,
        tagValue: 'Tag 11456',
        displayOrder: 7,
        isDeleted: false,
      },
      {
        tagValueId: 352,
        tagValue: 'Tag 21456',
        displayOrder: 8,
        isDeleted: false,
      },
      {
        tagValueId: 353,
        tagValue: 'Tag 33456',
        displayOrder: 9,
        isDeleted: false,
      },
      {
        tagValueId: 451,
        tagValue: 'Tag 411',
        displayOrder: 10,
        isDeleted: false,
      },
      {
        tagValueId: 452,
        tagValue: 'Tag 421',
        displayOrder: 12,
        isDeleted: false,
      },
      {
        tagValueId: 453,
        tagValue: 'Tag 433',
        displayOrder: 13,
        isDeleted: false,
      },
      {
        tagValueId: 561,
        tagValue: 'Tag 116',
        displayOrder: 14,
        isDeleted: false,
      },
      {
        tagValueId: 652,
        tagValue: 'Tag 261',
        displayOrder: 15,
        isDeleted: false,
      },
      {
        tagValueId: 653,
        tagValue: 'Tag 33',
        displayOrder: 16,
        isDeleted: false,
      },
    ],
    createdBy: 'Mike Taylor',
    createdOn: '2024-11-14T07:30:53.9656725Z',
    updatedBy: 'Mike Taylor',
    updatedOn: '2025-01-30T07:30:53.9656726Z',
  },
];
